export function date_format(parameters) {
  const [format] = parameters;
  return {
    format
  };
}
